import { listAdvertisers } from './listAdvertisers'
import { listPublishers } from './listPublishers'

export default {
  ...listAdvertisers,
  ...listPublishers
}
